import type { DeckConfig } from '../types';

export const DECKS: DeckConfig[] = [
  {
    id: 'bs',
    name: 'Betriebssysteme',
    icon: '🖥️',
    file: '/Betriebssysteme/Karteikarten_Betriebssysteme.md',
    summary: '/Betriebssysteme/Zusammenfassung_Betriebssysteme.md',
  },
  {
    id: 'db',
    name: 'Datenbanken',
    icon: '🗃️',
    file: '/Datenbanken/Karteikarten_Datenbanken.md',
    summary: '/Datenbanken/Zusammenfassung_Datenbanken.md',
  },
  {
    id: 'sec',
    name: 'Informationssicherheit',
    icon: '🔐',
    file: '/Informationssicherheit/Karteikarten_Informationssicherheit.md',
    summary: '/Informationssicherheit/Zusammenfassung_Informationssicherheit.md',
  },
  {
    id: 'net',
    name: 'Netze und Verteilte Systeme',
    icon: '🌐',
    file: '/Netze und Verteilte Systeme/Karteikarten_Netze.md',
    summary: '/Netze und Verteilte Systeme/Zusammenfassung_Netze.md',
  },
];

export function getDeck(id: string) {
  return DECKS.find((deck) => deck.id === id);
}
